export function obj(ctx) {
    return {
        // radius: 5 is a deliberate per-theme stylistic choice for this theme's generic-object
        // corner rounding, not a firmware match — firmware's real LV_THEME_OBJ radius is
        // LV_DPI/15 = 10 (lv_theme_hasp.c:251, via the shared "pretty" style, matched by the
        // schema's own default). Every bundled theme picks its own distinct small radius here
        // (hasp-light: 5, material-dark: 8, material-light: 4, mono: 5), confirming this is an
        // intentional per-theme visual-identity knob rather than a copy-paste mistake.
        styles: {
            main: { ...ctx.pretty, radius: 5 },
        },
    };
}
